<template>
  <div class="hello">
       <footer class="bd-footer bg-light">
  <div class="container-fluid py-5">
    <div class="row">
      <div class="col-lg-3 mb-3">
        <a class="d-inline-flex align-items-center mb-2 link-dark text-decoration-none" href="/" aria-label="Bootstrap">
          <img src="@/assets/images/Logo.jpg" style="width:52px;height:52px;"/>
          <span class="fs-5">Tradebees</span>
        </a>
        <ul class="list-unstyled small text-muted">
          <li class="mb-2">Designed and Developed by <a href="">Fligix India</a>.</li>
          <li class="mb-2">© Copyright 2021 <a href="https://github.com/twbs/bootstrap/blob/main/LICENSE" target="_blank" rel="license noopener"></a> <a href="https://creativecommons.org/licenses/by/3.0/" target="_blank" rel="license noopener"></a>.</li>
          
        </ul>
      </div>
      <div class="col-6 col-lg-4 offset-lg-1 mb-3">
        <h5>Links</h5>
        <ul class="list-unstyled">
          <li class="mb-2"><a href="/">Home</a></li>
          <li class="mb-2"><a href="/About">About</a></li>
          <li class="mb-2"><a href="/Courses">Courses</a></li>
          <li class="mb-2"><a href="/TrainingBlog">Training Blog</a></li>
          <li class="mb-2"><a href="/Training">Training</a></li>
        </ul>
      </div>
      <!-- <div class="col-6 col-lg-2 mb-3">
        <h5>Guides</h5>
        <ul class="list-unstyled">
          <li class="mb-2"><a href="/docs/5.0/getting-started/">Getting started</a></li>
          <li class="mb-2"><a href="/docs/5.0/examples/starter-template/">Starter template</a></li>
          <li class="mb-2"><a href="/docs/5.0/getting-started/webpack/">Webpack</a></li>
          <li class="mb-2"><a href="/docs/5.0/getting-started/parcel/">Parcel</a></li>
        </ul>
      </div> -->
      <!-- <div class="col-6 col-lg-2 mb-3">
        <h5>Projects</h5>
        <ul class="list-unstyled">
          <li class="mb-2"><a href="https://github.com/twbs/bootstrap">Bootstrap 5</a></li>
          <li class="mb-2"><a href="https://github.com/twbs/bootstrap/tree/v4-dev">Bootstrap 4</a></li>
          <li class="mb-2"><a href="https://github.com/twbs/icons">Icons</a></li>
          <li class="mb-2"><a href="https://github.com/twbs/rfs">RFS</a></li>
          <li class="mb-2"><a href="https://github.com/twbs/bootstrap-npm-starter">npm starter</a></li>
        </ul>
      </div> -->
      <div class="col-6 col-lg-4 mb-3">
        <h5>Community</h5>
        <ul class="list-unstyled">
          <li class="mb-2"><a href="https://telegram.me/s/tradebees1">Telegram</a></li>
          <li class="mb-2"><a href="https://www.facebook.com/tradebees">Facebook</a></li>
          <li class="mb-2"><a href="https://twitter.com/bees_trade">Twitter</a></li>
          <li class="mb-2"><a href="https://www.youtube.com/channel/UC9H5dir7-7etul1bp-i7bAA">YouTube</a></li>
          <li class="mb-2"><a href="/Register">Register</a></li>
          <li class="mb-2"><a href="/Login">Login</a></li>
        </ul>
      </div>
    </div>
  </div>
</footer>
   </div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";

@Options({
  props: {
    msg: String,
  },
})
export default class NavBar extends Vue {
  
}
</script>


<style>

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
</style>